export const joinStringArrayWith =
    <Separator extends string>(separator: Separator) =>
    <T extends string[]>(...strings: T): ConcatStringArray<T, Separator> =>
        strings.join(separator) as ConcatStringArray<T, Separator>

declare type ConcatStringArray<
    Arr extends Readonly<string[]>,
    Separator extends string,
> = ConcatStringArrayRec<Arr, '', Separator>

declare type ConcatStringArrayRec<
    T extends Readonly<string[]>,
    Acc extends Readonly<string>,
    Separator extends string,
> =
    T extends Readonly<
        [
            infer F extends Readonly<string>,
            ...infer Rest extends Readonly<string[]>,
        ]
    >
        ? ConcatStringArrayRec<Rest, `${Acc}${Separator}${F}`, Separator>
        : Acc
